import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isChangeProfilePictureRequestFailure() {
      return getState().isFailure;
    },
    isChangeProfilePictureRequestPending() {
      return getState().isPending;
    },
    isChangeProfilePictureRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
